import gql from 'graphql-tag'

export default gql`mutation updateSystemSetting($data: SystemSettingInput!) {
    updateSystemSetting(data: $data) @client
}`